const base_url = process.env.NODE_ENV == 'production' ? process.env.VUE_APP_BASE_URL : process.env.VUE_APP_BASE_URL_DEV
const ws_url = process.env.VUE_APP_WS
export default {
    base_url,
    ws_url
}